import React from "react";

import type { PdfTocEntry } from "./types.d";

type PdfTocProps = {
  toc?: PdfTocEntry[] | null;
  showPageNumberPlaceholders?: boolean;
};

// Ported from views/printToc.html.
export default function PdfToc(props: Readonly<PdfTocProps>) {
  const { showPageNumberPlaceholders, toc } = props;

  if (!toc || toc.length === 0) {
    return null;
  }

  return (
    <table className="print-page-break toc-table">
      <tbody>
        <tr>
          <td className="toc-left-column">
            <h2 className="toc-left-title">Innhold</h2>
          </td>
        </tr>
        <tr>
          <td className="toc-right-column">
            <ol>
              {toc.map((chapter) => (
                <li key={chapter.id} className="toc toc-right-text">
                  <a href={`#${chapter.id}`}>
                    <span className="toc-title">{chapter.name}</span>
                    {(chapter.pageNumber || showPageNumberPlaceholders) && (
                      <>
                        <span className="toc-page-leader" style={{ overflow: "hidden" }}>...................................................................................................................................</span>
                        <span className="toc-page-number">
                          {chapter.pageNumber ?? ""}
                        </span>
                      </>
                    )}
                  </a>
                </li>
              ))}
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
